import { h } from "preact";
import { Sample } from "./Sample";
import { render } from "@testing-library/preact";
import { expect } from "chai";

describe("Test Hello World", () => {
  it("hello-world component", () => {
    const content = render(
      <Sample preferredGreeting="Goodbye" />
    );

    const message = content.queryByText("Goodbye", { exact: false });
    expect(message).not.null;
  });
});
